import forDevice from '../../hoc/for-device';
import PostPageMetadataDesktop from './post-page-metadata-desktop';
import PostPageMetadataMobile from './post-page-metadata-mobile';

export default forDevice(PostPageMetadataMobile, PostPageMetadataDesktop);
